import React from 'react';
import { detectPlatform } from './FloatingContactStack';

export const APP_STORE_URL = 'https://apps.apple.com/app/id6813460272';
export const APP_STORE_LIVE = false;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const isInsideNativeApp = () => {
  try {
    return detectPlatform().isStandalone || !!(window.webkit && window.webkit.messageHandlers);
  } catch (_e) {
    return false;
  }
};

const deviceType = () => {
  const { isIOS, isAndroid } = detectPlatform();
  return isIOS ? 'ios' : isAndroid ? 'android' : 'desktop';
};

export const logAppStoreClick = (source, lang) => {
  try {
    fetch(`${API}/app-store-click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ source, device: deviceType(), lang: lang || 'unknown', tz: Intl.DateTimeFormat().resolvedOptions().timeZone }),
      keepalive: true,
    });
  } catch (_e) { /* ignore */ }
};

const AppleLogo = () => (
  <svg viewBox="0 0 384 512" className="w-6 h-6 fill-white" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

const PlayLogo = () => (
  <svg viewBox="0 0 512 512" className="w-5 h-5" aria-hidden="true">
    <path fill="#34A853" d="M48 32l232 224L48 480c-9-5-16-15-16-28V60c0-13 7-23 16-28z" />
    <path fill="#FBBC04" d="M352 184l-72 72 72 72 88-50c25-14 25-30 0-44z" />
    <path fill="#4285F4" d="M48 32c6-3 14-3 22 1l282 151-72 72z" />
    <path fill="#EA4335" d="M280 256l72 72L70 479c-8 4-16 4-22 1z" />
  </svg>
);

const SOON = { el: 'Σύντομα στο', en: 'Coming soon to' };

export const AppStoreBadge = ({ source, lang, size = 'md', testid }) => {
  if (!APP_STORE_LIVE || isInsideNativeApp()) return null;
  const big = size === 'lg';
  if (deviceType() === 'android') {
    return (
      <div
        className={`inline-flex items-center gap-2.5 rounded-xl bg-black/80 border border-white/20 text-white/80 ${big ? 'px-5 py-2.5' : 'px-4 py-2'}`}
        data-testid={`${testid}-android-soon`}
      >
        <PlayLogo />
        <span className="flex flex-col leading-none text-left">
          <span className="text-[10px] uppercase tracking-wide">{SOON[lang] || SOON.en}</span>
          <span className={`${big ? 'text-lg' : 'text-base'} font-semibold`}>Google Play</span>
        </span>
      </div>
    );
  }
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => logAppStoreClick(source, lang)}
      className={`inline-flex items-center gap-2.5 rounded-xl bg-black border border-white/40 hover:border-[#c9a84c] hover:scale-[1.03] transition-transform duration-300 shadow-[0_8px_24px_-10px_rgba(0,0,0,0.8)] ${big ? 'px-5 py-2.5' : 'px-4 py-2'}`}
      data-testid={testid}
    >
      <AppleLogo />
      <span className="flex flex-col leading-none text-left text-white">
        <span className="text-[10px] tracking-wide">Download on the</span>
        <span className={`${big ? 'text-xl' : 'text-lg'} font-semibold -mt-0.5`}>App Store</span>
      </span>
    </a>
  );
};
